import type { DummyFoods } from './dummyFoods'

export const pepper: DummyFoods = {
  Pepper: {
    Chili: ['Chili peppers'],
    'Green bell': ['Green bell pepper'],
    Jalapeno: ['Jalapeno peppers'],
    Poblano: ['Poblano pepper'],
    'Red bell': ['Red bell pepper'],
    Serrano: ['Serrano pepper'],
  },
}
